import { CIcon } from '~/icons/types'

export const ciJetSki: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.662 12.833a.5.5 0 0 0-.441-.266h-.314c-1.567-1.842-5.32-3.3-7.517-4.029l-2.114-1.45a.5.5 0 0 0-.486-.045l-1.592.707a.5.5 0 1 0 .406.914l1.337-.594.72.494a2.16 2.16 0 0 0-.6.335l-2.568 2.136a1.307 1.307 0 0 1-1.068.228L1.841 9.691A1.638 1.638 0 0 0 .483 10a1.133 1.133 0 0 0-.146 1.669c.186.202.425.35.69.424l.576.168a2.928 2.928 0 0 0-.076 2.572H.501a.5.5 0 0 0-.412.784l.831 1.205c.309.44.708.81 1.17 1.085a.508.508 0 0 0 .26.072l17.6-.057a.5.5 0 0 0 .27-.081 3.62 3.62 0 0 0 1.21-1.251l2.2-3.246a.5.5 0 0 0 .032-.511ZM1.084 11.008a.168.168 0 0 1-.047-.1.2.2 0 0 1 .083-.134.647.647 0 0 1 .524-.1l7.583 1.572a2.308 2.308 0 0 0 1.91-.438l2.569-2.135a1.424 1.424 0 0 1 1.3-.2 23.43 23.43 0 0 1 6.466 3.1h-7.111a9.6 9.6 0 0 0-4.435 1.075l-7.414-2.155-1.2-.35a.484.484 0 0 1-.228-.135Zm1.176 2.624c.004-.383.114-.758.316-1.084l6.151 1.789a7.401 7.401 0 0 1-3.622.507c-.275 0-.553-.008-.834-.008h-1.61a2.122 2.122 0 0 1-.4-1.204Zm18.32 2.437c-.194.34-.462.63-.784.853l-17.3.057a2.733 2.733 0 0 1-.75-.724l-.29-.422h2.82c.275 0 .548 0 .82.008 1.567.03 3.194.054 4.51-.864a8.36 8.36 0 0 1 4.755-1.408h7.917l-1.698 2.5Z',
      fill: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'jet-ski',
  type: 'thin'
}
